var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.942,
    height: 16,
    viewBox: "0 0 15.942 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M15.459,0a1.334,1.334,0,0,1,1.332,1.337V14.663A1.334,1.334,0,0,1,15.459,16H2.18A1.334,1.334,0,0,1,.849,14.663V1.337A1.334,1.334,0,0,1,2.18,0ZM11.625,6A2.53,2.53,0,0,0,9.382,7.072l-.064.117V6.1H7.159v7.667H9.484V10.053c0-1.245.457-2.036,1.554-2.036.75,0,1.069.659,1.1,1.835l0,.2v3.714h2.325V9.532C14.466,7.246,13.921,6,11.625,6ZM5.5,6H3.174v7.667H5.5ZM4.336,2A1.5,1.5,0,1,0,5.831,3.5,1.5,1.5,0,0,0,4.336,2Z",
    transform: "translate(-0.849)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f3d4e08fa62f0ef10831fcc5591f3c14.svg";
export { ForwardRef as ReactComponent };